module.exports = __webpack_public_path__ + "docs/img/robot-right.29b5c40d.png";